import { compact, flow, head, split } from 'lodash/fp';

const formatUrlPath = ({ pathname }: { pathname?: string } = {}) => {
  if (!pathname) {
    return null;
  }

  return flow(
    split(/[/?]/g), // Split on / OR ? to remove query params from the base path to get the first part of the path
    compact,
    head,
  )(pathname);
};

export default formatUrlPath;
